var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.showLoading ? _c('loading') : _vm._e(), _vm.errorMessage ? _c('div', {
    staticClass: "container error-message-box justify-content-center align-items-center"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h5', [_vm._v(_vm._s(_vm.errorMessage))]), _c('b-button', {
    staticClass: "mb-1 mt-3",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 回官方帳號 ")])], 1)]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }